import { useTranslation } from 'react-i18next';

type I18nBreadcrumbProps = {
  translationKey: string;
};

export const I18nBreadcrumb = ({ translationKey }: I18nBreadcrumbProps) => {
  const { t } = useTranslation();
  return <>{t(translationKey)}</>;
};
